// A fill-in template's spacing for the width it is shown at. The pack writes
// wide gaps between boxes (a=\placeholder[a]{},\quad p=...). On a phone the
// field is about 290 px wide at 360 px and 320 px at 390 px, and three boxes
// with \quad gaps ran 32 px past the field's edge (func-14, 9 October 2026).
// Below FIT_WIDTH_PX the gaps become an ordinary space. Display only: the
// server rebuilds the answer from its own copy of the template, and only the
// box values are sent.

export const FIT_WIDTH_PX = 440;

export function templateForWidth(template: string, widthPx: number): string {

  return widthPx > 0 && widthPx < FIT_WIDTH_PX
    ? template.replace(/\\(?:quad|qquad)(?![a-zA-Z])\s*/g, '\\ ')
    : template;
}
